"use strict";

exports.__esModule = true;
exports["default"] = getContainer;

var _reactDom = _interopRequireDefault(require("react-dom"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function getContainer(container, defaultContainer) {
  if (container == null) return defaultContainer;
  container = typeof container === 'function' ? container() : container;
  return _reactDom["default"].findDOMNode(container) || null;
}

module.exports = exports["default"];